<div class="workflow-steps-container mx-4">
  <div class="header">
    <h2>Workflow</h2>
    <button
      mat-stroked-button
      color="primary"
      (click)="loadWorkflowSteps()"
      [disabled]="loading"
    >
      Aggiorna
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="errorMessage" class="error">
    <mat-icon color="warn">error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <div *ngIf="!loading && !errorMessage">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z1 full-width-table"
      *ngIf="dataSource.length; else noData"
    >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let step">{{ step.id }}</td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let step">
          <span class="name-cell">
            <span>{{ step.nome }}</span>
            <mat-icon
              *ngIf="step.descrizione"
              class="info-icon"
              [matTooltip]="step.descrizione"
              matTooltipPosition="above"
              [matTooltipClass]="'workflow-steps-tooltip'"
            >
              help_outline
            </mat-icon>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="incarichi">
        <th mat-header-cell *matHeaderCellDef>Incarichi associati</th>
        <td mat-cell *matCellDef="let step">{{ getIncarichiCount(step) }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-header">Azioni</th>
        <td mat-cell *matCellDef="let step" class="actions-cell">
          <button
            mat-icon-button
            color="primary"
            matTooltip="Modifica descrizione"
            (click)="editDescription(step)"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; trackBy: trackByStepId"
      ></tr>
    </table>

    <ng-template #noData>
      <div class="empty-state">
        <mat-icon>info</mat-icon>
        <p>Nessun workflow step disponibile.</p>
      </div>
    </ng-template>
  </div>
</div>
